import React, { useEffect, useRef, useState } from "react";
import Alerts from "../util/Alerts";
import { Button, Card, CardBody, CardTitle, Col, Label, Row } from "reactstrap";
import BlkFormik from "../util/BlkFormik";
import { BlkField } from "../coms/BlkField";
import { Form } from "formik";
import { BlkCalendario } from "../coms/BlkCalendario";
import moment from "moment";
import ReactTable from "react-table";

import axios from "axios";
import { routes } from "./General";
import { find_aseguradoras, find_ram_grupos, find_ramos, find_ramos_ramgrp } from "../api/CacheApi";
import { pos } from "../util/General";
import { BlkCheckBox } from "../coms/BlkCheckBox";

export const GestorUsuario = props => {
    const [data, setData] = useState(getDefaultData());
    const [asegs, setAsegs] = useState([]);
    const [ramos, setRamos] = useState([]);
    const [nmCliGrupo, setNmCliGrupo] = useState([]);
    const [listSP, setListSP] = useState([]);
    const [all, setAll] = useState(false);

    const alert = useRef();
    const form = useRef();
    //const user = useSelector(state => state.user);

    useEffect(() => {
        fetchAsegs(setAsegs);
        fetchRamos(setRamos);
        fetchNmCliGrupo(setNmCliGrupo);
    }, []);

    const handleNuevaConsulta = () => {
        setListSP([]);
        setData(getDefaultData());
    };

    const onSubmit = (newValues, actions) => {
        const current = alert.current;
        setListSP([]);
        if (!newValues.fcDesde || !newValues.fcHasta) {
            setData(getDefaultData());
        } else {
            setData({ ...newValues, loading: true });
        }
        axios
            .post(routes.api + "/usuarios-vam-gestor", { ...newValues })
            .then(res => {
                handleQuery(res, data, setData);
                //current.show_info('Búsqueda Exitosa')
                actions.setSubmitting(false);
                setListSP([]);
                setAll(false);
            })
            .catch(err => {
                actions.setSubmitting(false);
                current.handle_error(err);
            });
    };

    const selectAll = valor => {
        let tmp = [];
        if (valor) {
            data.list.forEach(value => {
                tmp.push({
                    index: value.rownum,
                    cedula: value.cedula,
                    correo: value.correo,
                });
            });
        }
        setListSP(tmp);
        setAll(valor);
    };

    return (
        <div className="content">
            <Alerts ref={alert} />
            <Card>
                <CardBody>
                    <CardTitle tag="h4">Gestor Usuarios </CardTitle>
                    <div className="container-fluid">
                        <BlkFormik
                            initialValues={data}
                            onSubmit={onSubmit}
                            ref={form}
                            enableReinitialize={true}
                            validateOnChange={false}
                        >
                            {({ values, isSubmitting, errors, handleChange, submitForm }) => (
                                <Form>
                                    <Row>
                                        <Col lg={6}>
                                            <CardTitle className="text-center" tag="h6">
                                                Contratante
                                            </CardTitle>
                                            <Row>
                                                <div className={"form-group col-md-6 col-sm-12"}>
                                                    <Label>Nombre:</Label>
                                                    <BlkField
                                                        className="form-control"
                                                        type="text"
                                                        placeholder="Nombre"
                                                        name="nmContratante"
                                                    />
                                                </div>
                                                <div className={"form-group col-md-6 col-sm-12"}>
                                                    <Label>Apellido:</Label>
                                                    <BlkField
                                                        className="form-control"
                                                        type="text"
                                                        placeholder="Apellido"
                                                        name="apContratante"
                                                    />
                                                </div>
                                            </Row>
                                            <Row>
                                                <div className={"form-group col-md-6 col-sm-12"}>
                                                    <Label>Póliza:</Label>
                                                    <BlkField
                                                        className="form-control"
                                                        type="text"
                                                        placeholder="Póliza"
                                                        name="poliza"
                                                    />
                                                </div>
                                                <div className={"form-group col-md-6 col-sm-12"}>
                                                    <Label>Ramo:</Label>
                                                    <BlkField
                                                        component="select"
                                                        className="form-control w-100 inputTable"
                                                        name="ramo"
                                                    >
                                                        <option value="0">--TODOS--</option>
                                                        {ramos.map(ramo => (
                                                            <option key={ramo.cdRamo} value={ramo.cdRamo}>
                                                                {ramo.nmRamo}
                                                            </option>
                                                        ))}
                                                    </BlkField>
                                                </div>
                                            </Row>
                                            <Row>
                                                <div className={"form-group col-md-6 col-sm-12"}>
                                                    <Label>Grupo contratante:</Label>
                                                    <BlkField
                                                        component="select"
                                                        className="form-control w-100 inputTable"
                                                        name="nmCliGrupo"
                                                    >
                                                        <option value="0">--TODOS--</option>
                                                        {nmCliGrupo.map(n => (
                                                            <option key={n.cdCliGrupo} value={n.cdCliGrupo || ""}>
                                                                {n.nmCliGrupo}
                                                            </option>
                                                        ))}
                                                    </BlkField>
                                                </div>
                                                <div className={"form-group col-md-6 col-sm-12"}>
                                                    <Label>Aseguradora:</Label>
                                                    <BlkField
                                                        component="select"
                                                        className="form-control w-100 inputTable"
                                                        name="aseg"
                                                    >
                                                        <option value="0">--TODOS--</option>
                                                        {asegs.map(aseg => (
                                                            <option key={aseg.cdAseguradora} value={aseg.cdAseguradora}>
                                                                {aseg.nmAlias}
                                                            </option>
                                                        ))}
                                                    </BlkField>
                                                </div>
                                            </Row>
                                            <Row>
                                                <div className={"form-group col-md-3 col-sm-6"}>
                                                    <Label>Desde:</Label>
                                                    <BlkField
                                                        name={"fcDesde"}
                                                        placeholder={"Desde"}
                                                        component={BlkCalendario}
                                                    />
                                                </div>
                                                <div className={"form-group col-md-3 col-sm-6"}>
                                                    <Label>Hasta:</Label>
                                                    <BlkField
                                                        name={"fcHasta"}
                                                        placeholder={"Hasta"}
                                                        component={BlkCalendario}
                                                    />
                                                </div>
                                            </Row>
                                        </Col>
                                        <Col lg={6}>
                                            <CardTitle className={"text-center"} tag={"h6"}>
                                                Asegurado
                                            </CardTitle>
                                            <Row>
                                                <div className={"form-group col-md-6 col-sm-12"}>
                                                    <Label>Nombre:</Label>
                                                    <BlkField
                                                        className="form-control"
                                                        type="text"
                                                        placeholder="Nombre"
                                                        name="nmAsegurado"
                                                    />
                                                </div>
                                                <div className={"form-group col-md-6 col-sm-12"}>
                                                    <Label>Apellido:</Label>
                                                    <BlkField
                                                        className="form-control"
                                                        type="text"
                                                        placeholder="Apellido"
                                                        name="apAsegurado"
                                                    />
                                                </div>
                                            </Row>
                                            <Row>
                                                <div className={"form-group col-md-6 col-sm-12"}>
                                                    <Label>Cédula/RUC:</Label>
                                                    <BlkField
                                                        className="form-control"
                                                        type="text"
                                                        placeholder="Cédula/RUC"
                                                        name="cedula"
                                                    />
                                                </div>
                                                <div className={"form-group col-md-6 col-sm-12"}>
                                                    <Label>Correo:</Label>
                                                    <BlkField
                                                        className="form-control"
                                                        type="text"
                                                        placeholder="Correo"
                                                        name="correo"
                                                    />
                                                </div>
                                                <div className="form-group col-xs-2 d-flex mt-2 mx-3 align-items-center">
                                                    <Label className={"mr-2"}>Solo Inactivos</Label>
                                                    <BlkField
                                                        component={BlkCheckBox}
                                                        styleInput={{ marginLeft: 0, marginTop: "-10px" }}
                                                        name={"inactivos"}
                                                    />
                                                </div>
                                            </Row>
                                        </Col>
                                    </Row>
                                    <br />
                                    <Row>
                                        <div className="form-group col-md-6 col-sm-12">
                                            <Button
                                                type={"submit"}
                                                color="primary"
                                                className="mx-2"
                                                onClick={submitForm}
                                                disabled={isSubmitting}
                                            >
                                                Buscar
                                            </Button>
                                            <Button color="yellow" onClick={handleNuevaConsulta}>
                                                Nueva Consulta
                                            </Button>
                                        </div>
                                        <div className={"form-group col-lg-6 col-md-6 col-sm-12"}>
                                            <div className="row mx-1">
                                                {listSP.length > 0 && (
                                                    <Button
                                                        color="success"
                                                        className="mx-2"
                                                        onClick={() => handleCreaUsrWeb(listSP, alert, submitForm)}
                                                    >
                                                        Activar consultas web
                                                    </Button>
                                                )}
                                                {listSP.length > 0 && (
                                                    <Button
                                                        color="danger"
                                                        onClick={() => handleDesUrsWeb(listSP, alert, submitForm)}
                                                    >
                                                        Desactivar consultas web
                                                    </Button>
                                                )}
                                                <div className="form-check mx-2">
                                                    <label className="form-check-label">
                                                        <input
                                                            className="form-check-input"
                                                            type="checkbox"
                                                            style={{ cursor: "pointer" }}
                                                            checked={all}
                                                            defaultChecked={all}
                                                            onChange={e => {
                                                                selectAll(e.target.checked);
                                                            }}
                                                        />
                                                        <span className="form-check-sign">
                                                            Seleccionar Todos los Usuarios
                                                        </span>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </Row>
                                </Form>
                            )}
                        </BlkFormik>
                        <Row>
                            <Col xs={12}>
                                <ReactTable
                                    noDataText={"No se han encontrado datos"}
                                    previousText={"Anterior"}
                                    nextText={"Siguiente"}
                                    pageText={"Página"}
                                    rowsText={"filas"}
                                    ofText={"de"}
                                    columns={[
                                        {
                                            Header: "Contratante",
                                            columns: [
                                                {
                                                    Header: "Nombres",
                                                    minResizeWidth: 50,
                                                    width: 140,
                                                    accessor: "nmContratante",
                                                },
                                                {
                                                    Header: "Apellidos",
                                                    minResizeWidth: 50,
                                                    width: 140,
                                                    accessor: "apContratante",
                                                },
                                            ],
                                        },
                                        {
                                            Header: "Asegurado VAM",
                                            columns: [
                                                {
                                                    Header: "Título",
                                                    minResizeWidth: 50,
                                                    width: 60,
                                                    accessor: "titulo",
                                                },
                                                {
                                                    Header: "Nm Asegurado",
                                                    minResizeWidth: 50,
                                                    width: 140,
                                                    accessor: "nmAsegudado",
                                                },
                                                {
                                                    Header: "Ap Asegurado",
                                                    minResizeWidth: 50,
                                                    width: 140,
                                                    accessor: "apAsegudado",
                                                },
                                                {
                                                    Header: "Cédula",
                                                    minResizeWidth: 50,
                                                    width: 100,
                                                    accessor: "cedula",
                                                },
                                                {
                                                    Header: "Correo Asegurado",
                                                    minResizeWidth: 50,
                                                    width: 200,
                                                    accessor: "correo",
                                                },
                                            ],
                                        },
                                        {
                                            Header: "Aseg",
                                            minResizeWidth: 10,
                                            accessor: "aseg",
                                            width: 100,
                                        },
                                        {
                                            Header: "Ramo",
                                            minResizeWidth: 10,
                                            accessor: "ramo",
                                            width: 100,
                                        },
                                        {
                                            Header: "Póliza",
                                            minResizeWidth: 10,
                                            accessor: "poliza",
                                            width: 80,
                                        },
                                        {
                                            id: "selected",
                                            Header: "Sel.",
                                            minResizeWidth: 10,
                                            width: 50,
                                            Cell: row => {
                                                return (
                                                    <div>
                                                        <input
                                                            type="checkbox"
                                                            style={{ cursor: "pointer" }}
                                                            defaultChecked={
                                                                listSP.filter(i => i.index === row.original.rownum)
                                                                    .length > 0
                                                            }
                                                        />
                                                    </div>
                                                );
                                            },
                                        },
                                        {
                                            Header: "Usr. Web",
                                            minResizeWidth: 10,
                                            accessor: "activaWeb",
                                            width: 70,
                                            Cell: row => {
                                                return row.original.activaWeb === 1 ? (
                                                    <p>
                                                        <span className={"badge badge-success"}>SI</span>
                                                    </p>
                                                ) : (
                                                    <p>
                                                        <span className={"badge badge-danger"}>NO</span>
                                                    </p>
                                                );
                                            },
                                        },
                                        {
                                            id: "fcDesde",
                                            Header: "Fc Desde",
                                            accessor: d => {
                                                return moment(d.fcDesde)
                                                    .locale("moment/locale/es")
                                                    .local()
                                                    .format("DD/MM/YYYY");
                                            },
                                            minResizeWidth: 10,
                                            width: 100,
                                        },
                                        {
                                            id: "fcHasta",
                                            Header: "Fc Hasta",
                                            accessor: d => {
                                                return moment(d.fcHasta)
                                                    .locale("moment/locale/es")
                                                    .local()
                                                    .format("DD/MM/YYYY");
                                            },
                                            minResizeWidth: 10,
                                            width: 100,
                                        },
                                    ]}
                                    getTdProps={(state, rowInfo, column) => {
                                        if (rowInfo && rowInfo.row) {
                                            return {
                                                onClick: (e, handleOriginal) => {
                                                    if (column.id === "selected") {
                                                        handleListSP(rowInfo, listSP, setListSP, setAll, data.list);
                                                    }
                                                    if (handleOriginal) {
                                                        handleOriginal();
                                                    }
                                                },
                                                style: {
                                                    cursor: "pointer",
                                                    //backgroundColor: rowInfo.index === state.selected ? '#47b2a2' : 'white',
                                                    //color: rowInfo.index === state.selected ? 'white' : 'black',
                                                    height: 35,
                                                },
                                            };
                                        } else {
                                            return {};
                                        }
                                    }}
                                    manual
                                    data={data.list}
                                    pages={data.pages}
                                    loading={data.loading}
                                    onFetchData={(state, instance) => {
                                        if (data.list.length !== 0) {
                                            setData({ ...data, loading: true });
                                            axios
                                                .post(routes.api + "/usuarios-vam-gestor", {
                                                    ...data,
                                                    page: state.page,
                                                    pageSize: state.pageSize,
                                                    //sorted: state.sorted,
                                                })
                                                .then(res => {
                                                    handleQuery(res, data, setData);
                                                    setListSP([]);
                                                    setAll(false);
                                                })
                                                .catch(err => err);
                                        }
                                    }}
                                    sortable={false}
                                    defaultPageSize={10}
                                    className="-striped -highlight"
                                ></ReactTable>
                            </Col>
                        </Row>
                    </div>
                </CardBody>
            </Card>
        </div>
    );
};

export const fetchAsegs = setAsegs => {
    find_aseguradoras().then(resp => {
        setAsegs(resp);
    });
};

export const fetchRamos = setRamos => {
    find_ramos().then(resp => {
        let ramos = resp;
        find_ram_grupos().then(resp => {
            let areas = resp;
            find_ramos_ramgrp().then(resp => {
                let ramosTmp = [];
                resp.forEach(r => {
                    let item = Object.assign({}, r); //clono el item
                    item.nmRamo = ramos.find(ramo => ramo.cdRamo === item.cdRamo).nmRamo;
                    item.nmArea = areas.find(area => area.cdRamGrupo === item.cdRamGrupo).nmRamGrupo;
                    item.nm = item.nmRamo;
                    if (isVam(item)) {
                        ramosTmp.push(item);
                    }
                });
                setRamos(ramosTmp.sort((a, b) => a.nmRamo.localeCompare(b.nmRamo)));
            });
        });
    });
};

export const fetchNmCliGrupo = setNmCliGrupo => {
    axios
        .get(routes.api + "/usuarios-vam-cli-grupo")
        .then(res => {
            setNmCliGrupo(res.data);
        })
        .catch(err => err);
};

const isVam = r => {
    let vam = false;
    let ls_nm_grp_ramo = r.nmArea;

    if (pos(ls_nm_grp_ramo, "MEDICA") > 0) {
        //pb_actvam.TriggerEvent(Clicked!)
        vam = true;
    } else if (pos(ls_nm_grp_ramo, "VIDA") > 0) {
        //pb_actvam.TriggerEvent(Clicked!)
        vam = true;
    } else {
        vam = false;
    }
    return vam;
};

export const getDefaultData = () => ({
    list: [],
    page: 0,
    pages: -1,
    pageSize: 10,
    loading: false,
    nmContratante: "",
    apContratante: "",
    poliza: "",
    ramo: 0,
    aseg: 0,
    nmCliGrupo: 0,
    fcDesde: new Date(new Date().getFullYear() - 1, new Date().getMonth(), 1),
    fcHasta: new Date(),
    nmAsegurado: "",
    apAsegurado: "",
    cedula: "",
    correo: "",
    inactivos: false,
});

export const handleQuery = (query, data, setData) => {
    let q = [];
    query.data.content.forEach(i => {
        q.push({
            rownum: i[0],
            cedula: i[1],
            nmAsegudado: i[2],
            inclusion: i[3],
            exclusion: i[4],
            apAsegudado: i[5],
            aseg: i[6],
            ramo: i[7],
            poliza: i[8],
            fcDesde: i[9],
            fcHasta: i[10],
            fcNacimiento: i[11],
            genero: i[12],
            estadoCivil: i[13],
            profesion: i[14],
            titulo: i[15],
            nmConyuge: i[16],
            apConyuge: i[17],
            celular: i[18],
            correo: i[19],
            valido: i[20],
            fcValido: i[21],
            acepta: i[22],
            fcAcepta: i[23],
            validadoWs: i[24],
            fcValidadoWs: i[25],
            usroCdgo: i[26],
            fcCreacion: i[27],
            usuarioWeb: i[28],
            activaWeb: i[29],
            activado: i[30],
            notas: i[31],
            nmContratante: i[32],
            apContratante: i[33],
            grupoCont: i[34],
            selecciona: i[35],
        });
    });
    setData({ ...data, list: q, pages: query.data.totalPages, loading: false });
};

export const handleListSP = (row, listSP, setListSP, setAll, list) => {
    if (listSP.filter(i => i.index === row.original.rownum).length > 0) {
        setListSP(listSP.filter(i => i.index !== row.original.rownum));
        setAll(false);
    } else {
        setListSP([
            ...listSP,
            {
                index: row.original.rownum,
                cedula: row.original.cedula,
                correo: row.original.correo,
            },
        ]);
        setAll(listSP.length === list.length);
    }
};

// llamado a los SP activa, desactiva web
export const handleCreaUsrWeb = (listSP, alert, submitForm) => {
    const current = alert.current;
    axios
        .post(routes.api + "/usuarios-vam-crear", listSP)
        .then(res => {
            current.show_info("Activados " + res.data);
            submitForm && submitForm();
        })
        .catch(err => current.handle_error(err));
};

export const handleDesUrsWeb = (listSP, alert, submitForm) => {
    const current = alert.current;
    axios
        .post(routes.api + "/usuarios-vam-desactivar", listSP)
        .then(res => {
            current.show_info("Desactivados " + res.data);
            submitForm && submitForm();
        })
        .catch(err => current.handle_error(err));
};
